module.exports = __webpack_public_path__ + "img/header-or-menachem-banot.aa96c4c4.png";